import { useState, useEffect, useCallback, useMemo } from 'react'
import Cookies from 'js-cookie'
import { cookiesDomain } from '@/utils/token'
import { filterRepeat, isNumber } from '@/utils/utils'
import { captureException } from '@/utils/track'

export const IKNOW_KEY = 'IKNOW_KEY'

export const storage = {
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value))
    },
    get(key) {
        try {
            if (!key) {
                return null
            }
            return JSON.parse(localStorage.getItem(key))
        } catch (error) {
            console.error(error, '获取storage')
            captureException('获取本地storage缓存有误', {
                anchor: `getStorage`,
                mustNotify: true,
                extra: { valueKey: JSON.stringify(key), value: JSON.stringify(localStorage.getItem(key)) }
            })
        }
    },
    remove(key) {
        localStorage.removeItem(key)
    }
}

export const cookie = {
    set(key, value) {
        Cookies.set(key, JSON.stringify(value), {
            expires: PROJECT_CONFIG.COOKIES_EXPIRES,
            domain: cookiesDomain,
            Secure: true,
            SameSite: 'None'
        })
    },
    get(key) {
        let values
        try {
            const cookieValue = Cookies.get(key)
            if (cookieValue === undefined) {
                values = cookieValue
            } else {
                values = JSON.parse(cookieValue)
            }
        } catch (error) {
            console.error('catchError', error)
        }
        return values
    },
    remove(key) {
        Cookies.remove(key, {
            expires: PROJECT_CONFIG.COOKIES_EXPIRES,
            domain: cookiesDomain
        })
    }
}

// 获取存储 "我知道了" 的key数组
const getIknowKeyList = () => {
    const splitPopkey = storage.get(IKNOW_KEY)
    if (splitPopkey) {
        return splitPopkey
    } else {
        return []
    }
}
let currentPageNameArr = []

export const clearCurrentPageIknowArr = () => {
    currentPageNameArr = []
}
// 需要顺序出现的 需要加setRender属性
export default ({ name, sort, setRender, autoClose = false, delay = 8000 }) => {
    const [status, setStatus] = useState(false)
    // 兼容之前 传入的setRender属性，以后传入需要排序传入isSort 和 sort 即可
    const isSort = useMemo(() => {
        if (setRender) {
            return true
        }
        return isNumber(sort)
    }, [sort, setRender])

    useEffect(() => {
        if (!get(name) && isSort) {
            currentPageNameArr.push({
                name,
                sort: sort || 0,
                setVisible: e => {
                    setStatus(e)
                }
            })
            currentPageNameArr = filterRepeat(currentPageNameArr, 'name').sort((a, b) => b.sort - a.sort)
        }
    }, [name])

    useEffect(() => {
        if (!get(name) && isSort) {
            setTimeout(() => {
                if (currentPageNameArr.length && currentPageNameArr[0].name === name) {
                    setStatus(true)
                }
            }, 500)
        }
    }, [currentPageNameArr.length])

    useEffect(() => {
        let $t
        if (!get(name) && !isSort) {
            setStatus(true)

            if (autoClose) {
                if ($t) {
                    clearTimeout($t)
                }
                $t = setTimeout(() => {
                    setStatus(false)
                }, delay)
            }
        }

        return () => {
            if ($t) {
                clearTimeout($t)
            }
        }
    }, [])

    const saveStatus = () => {
        setStatus(false)
        set(name)
        if (isSort && currentPageNameArr.length) {
            currentPageNameArr.shift()
            currentPageNameArr[0]?.setVisible(true)
            // setRender(name)
        }
    }

    const set = useCallback(() => {
        let keyList = getIknowKeyList()
        if (keyList.indexOf(name) !== -1) {
            return
        } else {
            keyList.push(name)
        }
        storage.set(IKNOW_KEY, keyList)
    }, [name])

    const get = useCallback(() => {
        let keyList = getIknowKeyList()
        if (keyList.indexOf(name) !== -1) {
            return true
        }
        return false
    }, [name])

    const remove = useCallback(() => {
        let keyList = getIknowKeyList()
        if (keyList.indexOf(name) !== -1) {
            // 找到元素并且删除
            keyList.splice(
                keyList.findIndex(item => item === name),
                1
            )
            storage.set(IKNOW_KEY, keyList)
        }
    }, [name])

    return {
        status,
        setStatus,
        saveStatus,
        get
    }
}
